import { render, staticRenderFns } from "./veStuScholarshipTypeEdit.vue?vue&type=template&id=0a4b1de4&scoped=true"
import script from "./veStuScholarshipTypeEdit.vue?vue&type=script&lang=js"
export * from "./veStuScholarshipTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b1de4",
  null
  
)

export default component.exports